/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ReactApexChart from 'react-apexcharts';

import { get } from '../../helpers/api_helper';
import { buildHorizontalBarOptions, dashboardPalette } from './chartTheme';

function TeardownProductivityChart(props) {
  const { t, date } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [data, setData] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);
  const [chartSeries, setChartSeries] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/api/tvs/reports/teardown?isoDay=${date}`);
        setData(response);
      } catch (error) {
        toastr.error(t('Error fetching teardown productivity data'));
      }
    };

    fetchData();
  }, [date]);

  useEffect(() => {
    if (data) {
      setChartOptions(buildHorizontalBarOptions({
        categories: data.map((item) => item.inducted_by),
        xTitle: 'TVs/Kits',
        tooltipFormatter: (val) => val,
        color: dashboardPalette.rose,
        barHeight: '42%',
        height: 220,
      }));

      setChartSeries([
        {
          name: 'TVs/Kits Completed',
          data: data.map((item) => item.sets),
        },
      ]);
    }
  }, [data]);

  return (
    <div className="dashboard-chart dashboard-chart--compact">
      {chartOptions && chartSeries && (
        <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={220} />
      )}
      {chartOptions === null && (
        <div className="text-center">
          <span className="mdi mdi-loading mdi-spin fs-2" />
        </div>
      )}
    </div>
  );
}

TeardownProductivityChart.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  date: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(TeardownProductivityChart));
